export const BLOG_POSTS = [
  {
    slug: "wordpress-hackeado-primeras-2-horas",
    title: "WordPress hackeado: qué hacer en las primeras 2 horas",
    excerpt: "Guía práctica para contener daños, recuperar operación y evitar reinfecciones cuando tu sitio fue comprometido.",
    category: "Seguridad WordPress",
    date: "2026-04-15",
    readTime: "8 min",
    seoDescription: "Pasos críticos para actuar en las primeras 2 horas tras un hackeo de WordPress: contención, respaldo forense, limpieza y recuperación segura.",
    keywords: "wordpress hackeado, recuperar wordpress, malware wordpress, seguridad wordpress",
    sections: [
      {
        heading: "1) Aísla y documenta antes de tocar nada",
        content: [
          "Activa modo mantenimiento o restringe acceso temporalmente para frenar impacto público.",
          "Guarda evidencia básica: hora del incidente, síntomas, urls afectadas, usuarios y cambios recientes.",
          "Genera una copia de archivos y base de datos para análisis forense antes de limpiar."
        ]
      },
      {
        heading: "2) Limpieza técnica con enfoque de causa raíz",
        content: [
          "No basta con borrar archivos sospechosos; hay que identificar vector de entrada (plugin, credenciales, hosting, etc.).",
          "Actualiza núcleo, plugins y temas a versiones estables y elimina componentes abandonados.",
          "Cambia contraseñas de WordPress, FTP/SFTP, panel y base de datos."
        ]
      },
      {
        heading: "3) Blindaje post-incidente",
        content: [
          "Configura firewall/WAF, políticas de login y monitoreo de integridad de archivos.",
          "Programa backups automáticos con retención y prueba restauraciones.",
          "Deja checklist de validación para evitar recurrencias."
        ]
      }
    ]
  },
  {
    slug: "core-web-vitals-wordpress-que-impacta-conversion",
    title: "Core Web Vitals en WordPress: qué sí mueve conversión",
    excerpt: "No todo en PageSpeed pesa igual para negocio. Enfócate en los cuellos de botella que sí afectan ventas y leads.",
    category: "SEO Técnico",
    date: "2026-04-12",
    readTime: "7 min",
    seoDescription: "Cómo priorizar optimización de Core Web Vitals en WordPress para mejorar UX, SEO y conversiones con impacto real.",
    keywords: "core web vitals wordpress, pagespeed wordpress, seo tecnico, conversion",
    sections: [
      {
        heading: "LCP: prioriza contenido principal",
        content: [
          "Optimiza imagen hero, elimina recursos bloqueantes y acelera respuesta del servidor.",
          "Un LCP alto frena percepción de velocidad y aumenta rebote."
        ]
      },
      {
        heading: "INP/FID: interacción sin retrasos",
        content: [
          "Reduce JavaScript innecesario, divide bundles y evita tareas largas en main thread.",
          "La respuesta lenta al primer clic afecta directamente formularios y checkout."
        ]
      },
      {
        heading: "CLS: estabilidad visual",
        content: [
          "Reserva espacio para imágenes/banners y evita inserciones tardías de elementos.",
          "Saltos de layout rompen confianza y disparan abandonos."
        ]
      }
    ]
  },
  {
    slug: "mantenimiento-wordpress-checklist-mensual",
    title: "Checklist mensual de mantenimiento WordPress (en serio útil)",
    excerpt: "Un mantenimiento real no es sólo actualizar plugins. Este checklist evita caídas, vulnerabilidades y pérdida de rendimiento.",
    category: "Mantenimiento",
    date: "2026-04-10",
    readTime: "6 min",
    seoDescription: "Checklist mensual de mantenimiento WordPress para seguridad, rendimiento y continuidad operativa sin improvisación.",
    keywords: "mantenimiento wordpress, checklist wordpress, seguridad wordpress, backup wordpress",
    sections: [
      {
        heading: "Seguridad base",
        content: [
          "Actualiza componentes críticos y elimina plugins inactivos.",
          "Revisa usuarios privilegiados y registra cambios relevantes."
        ]
      },
      {
        heading: "Resiliencia y respaldo",
        content: [
          "Verifica que backups estén corriendo y prueba restauraciones periódicas.",
          "Confirma monitoreo de uptime y alertas de errores."
        ]
      },
      {
        heading: "Rendimiento continuo",
        content: [
          "Revisa tiempos de carga en páginas clave y corrige regresiones.",
          "Optimiza base de datos y caché para sostener velocidad."
        ]
      }
    ]
  },
  {
    slug: "senales-wordpress-comprometido-antes-de-caer",
    title: "6 señales de WordPress comprometido antes de que tu sitio caiga",
    excerpt: "Muchos ataques no tumban el sitio al inicio. Aprende a detectar señales tempranas y cortar el problema antes de escalar.",
    category: "Seguridad WordPress",
    date: "2026-04-08",
    readTime: "5 min",
    seoDescription: "Cómo detectar señales tempranas de un WordPress comprometido y actuar antes de una caída o blacklist.",
    keywords: "wordpress comprometido, señales de malware, seguridad wordpress, blacklist",
    sections: [
      {
        heading: "Cambios invisibles al inicio",
        content: [
          "Aparición de usuarios administradores desconocidos o cambios en permisos sin explicación.",
          "Archivos nuevos en rutas sensibles como `wp-content/uploads` con nombres aleatorios."
        ]
      },
      {
        heading: "Señales técnicas en servidor y panel",
        content: [
          "Picos de consumo CPU/RAM en horarios raros y procesos PHP anómalos.",
          "Correos de hosting por spam saliente, redirecciones o detección de scripts sospechosos."
        ]
      },
      {
        heading: "Acción inmediata recomendada",
        content: [
          "Restringe accesos, respalda estado actual y congela cambios editoriales.",
          "Inicia revisión de integridad y rota credenciales críticas el mismo día."
        ]
      }
    ]
  },
  {
    slug: "recuperar-seo-despues-malware-wordpress",
    title: "Cómo recuperar SEO después de un malware en WordPress",
    excerpt: "Limpiar el hackeo no basta: hay que recuperar indexación, confianza y tráfico orgánico paso a paso.",
    category: "SEO Técnico",
    date: "2026-04-06",
    readTime: "7 min",
    seoDescription: "Plan práctico para recuperar SEO tras un incidente de malware en WordPress: limpieza, reindexación y seguimiento.",
    keywords: "recuperar seo wordpress, malware wordpress seo, reindexación google, blacklist",
    sections: [
      {
        heading: "1) Cerrar el incidente primero",
        content: [
          "Valida limpieza completa antes de solicitar reindexación para evitar recaídas.",
          "Revisa que no existan redirecciones ocultas ni páginas spam indexables."
        ]
      },
      {
        heading: "2) Saneamiento SEO técnico",
        content: [
          "Regenera sitemap, corrige canonicals y verifica cobertura en Search Console.",
          "Solicita revisión de seguridad si hubo avisos de phishing o malware."
        ]
      },
      {
        heading: "3) Recuperación de tráfico",
        content: [
          "Refuerza contenidos clave y enlazado interno en páginas estratégicas.",
          "Monitorea impresiones, CTR y keywords durante 4-8 semanas."
        ]
      }
    ]
  },
  {
    slug: "auditoria-plugins-wordpress-20-minutos",
    title: "Auditoría de plugins WordPress en 20 minutos (sin romper nada)",
    excerpt: "Una revisión breve y ordenada de plugins puede reducir riesgo y mejorar estabilidad sin afectar operación.",
    category: "Mantenimiento",
    date: "2026-04-03",
    readTime: "6 min",
    seoDescription: "Checklist rápido para auditar plugins de WordPress con foco en seguridad, estabilidad y rendimiento.",
    keywords: "auditoria plugins wordpress, mantenimiento wordpress, plugins vulnerables, estabilidad",
    sections: [
      {
        heading: "Inventario y criticidad",
        content: [
          "Clasifica plugins por impacto de negocio: seguridad, checkout, SEO, formularios.",
          "Marca como críticos los que, si fallan, afectan ventas o captación."
        ]
      },
      {
        heading: "Riesgo y soporte",
        content: [
          "Identifica plugins sin updates recientes, sin soporte o con historial de vulnerabilidades.",
          "Elimina duplicados funcionales para reducir superficie de ataque."
        ]
      },
      {
        heading: "Plan de actualización seguro",
        content: [
          "Actualiza primero en staging y valida flujos clave antes de producción.",
          "Documenta rollback rápido para cada plugin crítico."
        ]
      }
    ]
  },
  {
    slug: "hardening-wordpress-primera-hora",
    title: "Hardening WordPress: qué sí hacer en la primera hora",
    excerpt: "Si vas a blindar un sitio, empieza por medidas de impacto alto y ejecución inmediata.",
    category: "Guías de prevención",
    date: "2026-03-31",
    readTime: "6 min",
    seoDescription: "Medidas de hardening WordPress de alta prioridad para aplicar en la primera hora de trabajo.",
    keywords: "hardening wordpress, seguridad wordpress, protección wp-admin, firewall wordpress",
    sections: [
      {
        heading: "Bloqueo de accesos y credenciales",
        content: [
          "Activa MFA para administradores y obliga contraseñas robustas.",
          "Limita intentos de login y restringe rutas sensibles por IP cuando sea viable."
        ]
      },
      {
        heading: "Superficie de ataque",
        content: [
          "Desactiva XML-RPC si no lo necesitas y elimina usuarios inactivos.",
          "Revisa permisos de archivos y deshabilita edición de plugins/temas desde panel."
        ]
      },
      {
        heading: "Monitoreo y respuesta",
        content: [
          "Configura alertas de cambios de archivos y actividad de admins.",
          "Define protocolo de respuesta para incidentes de 0-24h."
        ]
      }
    ]
  },
  {
    slug: "error-500-wordpress-guia-diagnostico",
    title: "Error 500 en WordPress: diagnóstico rápido sin improvisar",
    excerpt: "Cuando aparece un 500, actuar sin orden complica todo. Esta guía te ayuda a resolver con método.",
    category: "WordPress hackeado",
    date: "2026-03-28",
    readTime: "7 min",
    seoDescription: "Guía práctica para diagnosticar y corregir error 500 en WordPress con pasos seguros y rápidos.",
    keywords: "error 500 wordpress, sitio caído wordpress, diagnostico wordpress, recovery wordpress",
    sections: [
      {
        heading: "1) Confirma alcance del fallo",
        content: [
          "Valida si afecta solo frontend, wp-admin o ambos.",
          "Consulta logs de PHP y servidor antes de desactivar componentes al azar."
        ]
      },
      {
        heading: "2) Aisla variables de riesgo",
        content: [
          "Prueba desactivar temporalmente plugins y cambiar a tema por defecto.",
          "Revisa límites de memoria, versiones PHP y cambios recientes de hosting."
        ]
      },
      {
        heading: "3) Restaura operación controlada",
        content: [
          "Rehabilita componentes por bloques y monitorea errores por cada cambio.",
          "Documenta causa raíz para prevenir reincidencia."
        ]
      }
    ]
  },
  {
    slug: "mejorar-ttfb-wordpress-sin-redisenar",
    title: "Cómo mejorar el TTFB en WordPress sin rediseñar tu web",
    excerpt: "No necesitas rehacer el sitio para bajar TTFB. Hay ajustes puntuales que sí mueven la aguja.",
    category: "Rendimiento",
    date: "2026-03-25",
    readTime: "6 min",
    seoDescription: "Ajustes concretos para reducir TTFB en WordPress sin rediseñar frontend ni perder funcionalidades.",
    keywords: "ttfb wordpress, rendimiento wordpress, velocidad servidor wordpress, cache wordpress",
    sections: [
      {
        heading: "Back-end primero",
        content: [
          "Optimiza caché de página/objeto y reduce consultas pesadas en home y categorías.",
          "Elimina plugins que ejecutan tareas síncronas en cada request."
        ]
      },
      {
        heading: "Servidor y base de datos",
        content: [
          "Ajusta versión PHP, workers y límites de memoria según tráfico real.",
          "Depura transients vencidos y tablas con overhead para reducir latencia."
        ]
      },
      {
        heading: "Monitoreo de mejora",
        content: [
          "Mide TTFB por plantilla crítica (home, producto, landing, blog).",
          "Define umbral objetivo y alerta automática ante regresiones."
        ]
      }
    ]
  },
  {
    slug: "plan-respuesta-incidentes-wordpress-pyme",
    title: "Plan de respuesta a incidentes WordPress para pymes",
    excerpt: "Un incidente no se gestiona bien improvisando. Este plan operativo te ahorra tiempo y pérdidas.",
    category: "Casos reales",
    date: "2026-03-22",
    readTime: "8 min",
    seoDescription: "Plantilla de plan de respuesta a incidentes WordPress para pymes con fases, responsables y tiempos.",
    keywords: "incidente wordpress, respuesta incidentes, plan seguridad pyme, wordpress recovery",
    sections: [
      {
        heading: "Fase 0-24h",
        content: [
          "Contener impacto, preservar evidencia y comunicar estado al negocio.",
          "Nombrar responsables de técnica, contenidos y comunicación."
        ]
      },
      {
        heading: "Fase 24-72h",
        content: [
          "Limpiar, validar integridad y recuperar servicios críticos.",
          "Actualizar vectores comprometidos y rotar credenciales de alto riesgo."
        ]
      },
      {
        heading: "Fase 7 días",
        content: [
          "Publicar lecciones aprendidas y checklist preventivo.",
          "Implementar controles permanentes de monitoreo y revisión mensual."
        ]
      }
    ]
  },
  {
    slug: "core-web-vitals-woocommerce-producto",
    title: "Core Web Vitals en WooCommerce: optimiza fichas de producto",
    excerpt: "Las fichas lentas venden menos. Prioriza los cambios que mejoran UX y conversión en ecommerce WordPress.",
    category: "SEO Técnico",
    date: "2026-03-19",
    readTime: "7 min",
    seoDescription: "Cómo optimizar Core Web Vitals en fichas de producto WooCommerce para mejorar ventas y visibilidad.",
    keywords: "core web vitals woocommerce, velocidad ficha producto, seo ecommerce wordpress, conversiones",
    sections: [
      {
        heading: "LCP en producto",
        content: [
          "Comprime imagen principal y precarga recurso hero del producto.",
          "Evita sliders pesados arriba del fold cuando no aportan conversión."
        ]
      },
      {
        heading: "Interacción y scripts",
        content: [
          "Retrasa scripts de terceros no críticos hasta interacción.",
          "Revisa variaciones, add-to-cart y widgets que bloquean hilo principal."
        ]
      },
      {
        heading: "Cierre comercial",
        content: [
          "Mide impacto en tasa de add-to-cart y checkout completion.",
          "Prioriza optimización en top SKUs y páginas con mayor margen."
        ]
      }
    ]
  }
];

export const BLOG_CONTENT_CATEGORIES = [
  {
    slug: "alertas-seguridad",
    label: "Alertas de seguridad",
    description: "Vulnerabilidades críticas, campañas activas y avisos oficiales con impacto inmediato."
  },
  {
    slug: "wordpress-hackeado",
    label: "WordPress hackeado",
    description: "Incidentes reales, recuperación, limpieza, forense y hardening post-ataque."
  },
  {
    slug: "mantenimiento-wordpress",
    label: "Mantenimiento WordPress",
    description: "Rutinas preventivas para estabilidad, actualizaciones seguras y continuidad operativa."
  },
  {
    slug: "casos-reales",
    label: "Casos reales",
    description: "Análisis de ataques y lecciones aplicables a sitios empresariales y ecommerce."
  },
  {
    slug: "guias-prevencion",
    label: "Guías de prevención",
    description: "Playbooks accionables para reducir superficie de ataque y blindar WordPress."
  },
  {
    slug: "seo-sem-wordpress",
    label: "SEO/SEM para WordPress",
    description: "Buenas prácticas de visibilidad, indexación y captación para crecimiento orgánico."
  }
];

export const FEED_KEYWORD_GROUPS = [
  {
    name: "Seguridad WordPress",
    keywords: ["wordpress hackeado", "malware", "vulnerabilidad", "limpieza", "hardening"]
  },
  {
    name: "Mantenimiento",
    keywords: ["actualizaciones", "backups", "uptime", "estabilidad", "prevención"]
  },
  {
    name: "SEO y rendimiento",
    keywords: ["seo técnico", "core web vitals", "velocidad web", "indexación", "conversiones"]
  }
];

export const RSS_REWRITE_RULES = [
  "Publicar como artículo propio con el formato editorial de WPRescate24.",
  "No incluir enlaces de salida ni mención de fuentes en el contenido final.",
  "Usar lenguaje claro, práctico y orientado a acciones concretas.",
  "Priorizar utilidad real para sitios WordPress de negocio.",
  "Cerrar cada artículo con CTA de soporte por WhatsApp."
];

export const RSS_PIPELINE_RECOMMENDATION = [
  {
    step: "Ingesta",
    stack: "Cron semanal",
    detail: "Recolectar tendencias 1 vez por semana y deduplicar por título/URL."
  },
  {
    step: "Selección editorial",
    stack: "Filtro temático",
    detail: "Elegir los temas más útiles para seguridad, mantenimiento, SEO y rendimiento."
  },
  {
    step: "Redacción propia",
    stack: "Guía editorial",
    detail: "Transformar la idea en artículo original con tono y estructura de WPRescate24."
  },
  {
    step: "Revisión",
    stack: "Control de calidad",
    detail: "Validar claridad, utilidad, consistencia SEO y CTA final."
  },
  {
    step: "Publicación",
    stack: "WordPress",
    detail: "Publicar 1 artículo por semana para mantener calidad y evitar saturación."
  }
];

export const RSS_SOURCES = [
  {
    name: "Raiola Networks",
    url: "https://raiolanetworks.com/blog/feed/",
    focus: "Seguridad WordPress, hardening y rendimiento",
    language: "es",
    priority: "high",
    categories: ["wordpress-hackeado", "guias-prevencion", "mantenimiento-wordpress"]
  },
  {
    name: "Hostinger Blog ES",
    url: "https://www.hostinger.com/es/blog/feed/",
    focus: "Guías de recuperación y operación WordPress",
    language: "es",
    priority: "high",
    categories: ["wordpress-hackeado", "guias-prevencion", "mantenimiento-wordpress"]
  },
  {
    name: "WPBeginner ES",
    url: "https://www.wpbeginner.com/es/feed/",
    focus: "Buenas prácticas y tutoriales evergreen",
    language: "es",
    priority: "medium",
    categories: ["mantenimiento-wordpress", "guias-prevencion"]
  },
  {
    name: "Kinsta Blog ES",
    url: "https://kinsta.com/es/blog/feed/",
    focus: "Contenido técnico en hosting, seguridad y performance",
    language: "es",
    priority: "high",
    categories: ["wordpress-hackeado", "mantenimiento-wordpress", "seo-sem-wordpress"]
  },
  {
    name: "Soporte-WordPress.es",
    url: "https://soporte-wordpress.es/feed/",
    focus: "Resolución de problemas reales y mantenimiento",
    language: "es",
    priority: "medium",
    categories: ["mantenimiento-wordpress", "guias-prevencion"]
  },
  {
    name: "The Hacker News",
    url: "https://feeds.feedburner.com/TheHackersNews",
    focus: "Campañas activas, malware y nuevas tácticas de ataque",
    language: "en",
    priority: "high",
    categories: ["alertas-seguridad", "casos-reales"]
  },
  {
    name: "Krebs on Security",
    url: "https://krebsonsecurity.com/feed/",
    focus: "Investigación profunda de brechas y cibercrimen",
    language: "en",
    priority: "high",
    categories: ["alertas-seguridad", "casos-reales"]
  },
  {
    name: "WordPress.com Blog",
    url: "https://wordpress.com/blog/feed/",
    focus: "Lineamientos y recomendaciones del ecosistema WordPress",
    language: "en",
    priority: "high",
    categories: ["wordpress-hackeado", "guias-prevencion"]
  },
  {
    name: "Jetpack Resources",
    url: "https://jetpack.com/resources/feed/",
    focus: "Seguridad WordPress y respuesta a incidentes",
    language: "en",
    priority: "high",
    categories: ["wordpress-hackeado", "guias-prevencion", "mantenimiento-wordpress"]
  },
  {
    name: "WPZOOM Blog",
    url: "https://www.wpzoom.com/blog/feed/",
    focus: "Recuperación, limpieza y prevención en WordPress",
    language: "en",
    priority: "medium",
    categories: ["wordpress-hackeado", "mantenimiento-wordpress"]
  },
  {
    name: "Schneier on Security",
    url: "https://www.schneier.com/feed/",
    focus: "Análisis estratégico para contenido educativo de alto valor",
    language: "en",
    priority: "medium",
    categories: ["casos-reales", "alertas-seguridad"]
  },
  {
    name: "CISA Alerts",
    url: "https://www.cisa.gov/news-events/alerts.xml",
    focus: "Alertas oficiales y vulnerabilidades críticas",
    language: "en",
    priority: "high",
    categories: ["alertas-seguridad", "casos-reales"]
  },
  {
    name: "BleepingComputer",
    url: "https://www.bleepingcomputer.com/feed/",
    focus: "Noticias de malware activo y amenazas emergentes",
    language: "en",
    priority: "high",
    categories: ["alertas-seguridad", "casos-reales", "wordpress-hackeado"]
  },
  {
    name: "Wordfence Blog",
    url: "https://www.wordfence.com/blog/feed/",
    focus: "Vulnerabilidades específicas del ecosistema WordPress",
    language: "en",
    priority: "high",
    categories: ["alertas-seguridad", "wordpress-hackeado", "guias-prevencion"]
  },
  {
    name: "Search Engine Journal",
    url: "https://www.searchenginejournal.com/feed/",
    focus: "Actualizaciones SEO/SEM y visibilidad orgánica",
    language: "en",
    priority: "medium",
    categories: ["seo-sem-wordpress", "casos-reales"]
  },
  {
    name: "Search Engine Land",
    url: "https://searchengineland.com/feed",
    focus: "Tendencias de posicionamiento y adquisición",
    language: "en",
    priority: "medium",
    categories: ["seo-sem-wordpress"]
  }
];
